import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { ShopOrderActions } from './order.actions';
import { ShopOrderState, shopOrderState } from './order.state';

export const shopOrderReducer = createReducer(
  shopOrderState,
  on(ShopOrderActions.reset, (): ShopOrderState => shopOrderState),
  on(
    ShopOrderActions.update,
    (state, args): ShopOrderState => ({ ...state, ...args })
  ),
  on(
    ShopOrderActions.setChip,
    (state, { chip }): ShopOrderState => ({ ...state, chip })
  ),
  on(
    ShopOrderActions.setPhone,
    (state, { phone }): ShopOrderState => ({ ...state, phone })
  ),
  on(ShopOrderActions.setCart, (state, { product }): ShopOrderState => {
    const carts: ShopOrderState['cart'] = [];
    if (product) {
      carts.push({
        type: 'main',
        product: product,
        quantity: 1
      });
    }

    return { ...state, product, cart: carts };
  }),
  on(
    ShopOrderActions.setPayment,
    (state, { payment }): ShopOrderState => ({ ...state, payment })
  ),
  on(
    ShopOrderActions.setVoucher,
    (state, { voucher }): ShopOrderState => ({ ...state, voucher })
  ),
  on(
    ShopOrderActions.setBilling,
    (state, { billing }): ShopOrderState => ({ ...state, billing })
  ),
  on(
    ShopOrderActions.setPaylater,
    (state, { paylater }): ShopOrderState => ({ ...state, paylater })
  ),
  on(
    ShopOrderActions.setQuantity,
    (state, { quantity, productId }): ShopOrderState => {
      const cart = cloneDeep(state.cart);
      if (cart.length > 0) {
        const itemIndex = cart.findIndex(
          (item) => item.product.id === productId
        );
        if (itemIndex >= 0) {
          cart[itemIndex].quantity = quantity;
        }
      }

      return { ...state, quantity, cart: cart };
    }
  ),
  on(ShopOrderActions.addCartItem, (state, { product }) => {
    const carts = cloneDeep(state.cart);

    if (carts.length > 0) {
      const itemIndex = carts.findIndex(
        (item) => item.product.id === product.id
      );
      if (itemIndex < 0) {
        carts.push({
          type: 'upsell',
          product: product,
          quantity: 1
        });
      }
    }

    return {
      ...state,
      cart: carts
    };
  }),
  on(
    ShopOrderActions.setShipment,
    (state, { shipment }): ShopOrderState => ({ ...state, shipment })
  ),
  on(
    ShopOrderActions.setShipping,
    (state, { shipping }): ShopOrderState => ({ ...state, shipping })
  ),
  on(
    ShopOrderActions.setInstallment,
    (state, { installment }): ShopOrderState => ({ ...state, installment })
  ),
  on(
    ShopOrderActions.setHomeservice,
    (state, { homeservice }): ShopOrderState => ({ ...state, homeservice })
  ),
  on(ShopOrderActions.removeCartItem, (state, { productId }) => {
    const cart = cloneDeep(state.cart);
    if (cart.length > 0) {
      const productIndex = cart.findIndex(
        (item) => item.product.id === productId
      );
      if (productIndex > 0) {
        cart.splice(productIndex, 1);
      }
    }
    return {
      ...state,
      cart
    };
  }),
  on(ShopOrderActions.orderCheckoutSuccess, (state) => {
    return {
      ...state,
      cart: [],
      product: null,
      payment: null,
      voucher: null,
      billing: null,
      paylater: null,
      shipment: null,
      shipping: null,
      installment: null,
      homeservice: null
    };
  })
);
